// Adapted from https://github.com/Azure-Samples/ms-identity-b2c-javascript-spa
// The current application coordinates were pre-registered in a B2C tenant.
const apiConfig = {
    b2cScopes: ['https://pattanb2c.onmicrosoft.com/api/events.read',]
}

export default apiConfig
  